import DateFnsUtils from '@date-io/date-fns'
import { KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import * as React from 'react'
import { alpha } from '@material-ui/core/styles'
import useStyles from '../../assets/styles';
import { CalenderIcon } from 'src/components/Icons';
import { Grid } from '@material-ui/core';

export const DateTimeSelectorComponent = (props) => {
  const classes = useStyles();
  
  return props.fromTestIoT ? (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid item xs={12} md={12} className={classes.datePickerContainer}>
        <Grid item xs={12} md={6} >
            <KeyboardDatePicker
            disableToolbar
            variant="inline"
            format="MM/dd/yyyy"
            margin="none"
            id="date-picker-inline"
            value={props.selectedDate}
            onChange={props.handleDateChange}
            KeyboardButtonProps={{
                'aria-label': 'change date',
            }}
            style={{ 
                width: 'fit-content',
            }}
            keyboardIcon={<CalenderIcon />}
            InputProps={{
                disableUnderline: true,
                style: {
                fontSize: '14px'
                }
            }}
            />
        </Grid>
        <Grid item xs={12} md={6} >
            <KeyboardTimePicker
            margin="none"
            id="time-picker"
            value={props.selectedDate}
            onChange={props.handleDateChange}
            KeyboardButtonProps={{
                'aria-label': 'change time',
            }}
            className={classes.timePicker}
            keyboardIcon={<AccessTimeIcon style={{ fontSize: 18 }} />}
            InputProps={{
                disableUnderline: true,
                style: {
                fontSize: '14px'
                }
            }}
            />
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  ) : (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        disableToolbar
        variant="inline"
        format="MM/dd/yyyy"
        margin="normal"
        id="date-picker-inline"
        value={props.selectedDate}
        onChange={props.handleDateChange}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        style={{ width: '150px', marginTop: '0px', marginRight: '10px' }}
        keyboardIcon={<CalendarTodayIcon style={{ fontSize: 16 }} />}
        InputProps={{
          disableUnderline: true,
        }}
      />

      <KeyboardTimePicker
        margin="normal"
        id="time-picker"
        value={props.selectedDate}
        onChange={props.handleDateChange}
        KeyboardButtonProps={{
          'aria-label': 'change time',
        }}
        style={{ width: '150px', marginTop: '0px' }}
        keyboardIcon={<AccessTimeIcon style={{ fontSize: 18 }} />}
        InputProps={{
          disableUnderline: true,
        }}
      />
    </MuiPickersUtilsProvider>
  );
}